// extracted by mini-css-extract-plugin
export default {"r_alert":"alert_r_alert__OkB1+","r_alert_icon":"alert_r_alert_icon__K12y5"};